var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.articleBar !== null
    ? _c(
        "div",
        { staticClass: "d-flex flex-wrap" },
        _vm._l(_vm.articleBar, function(article) {
          return _c("article-card", {
            key: article.id,
            staticClass: "col-12 col-md-6 my-2",
            attrs: { "is-overlay-type": true, article: article }
          })
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }